import { LitElement, html } from "lit";
class BCAbbr extends LitElement {
  static get properties() {
    return {
      tooltip: { type: String, reflect: true },
    };
  }
  render() {
    return html`<abbr title="${this.tooltip}"><slot></slot></abbr>
      ${this.tooltip ? html`<bc-tooltip data-trigger-style="dashed">${this.tooltip}</bc-tooltip>` : ""} `;
  }
}
const initBCAbbr = () => {
  if (!window.customElements.get("bc-abbr")) {
    customElements.define("bc-abbr", BCAbbr);
  }
};
export { initBCAbbr };
